import React, { Component } from 'react';
import Image from '../Image';

class Gallery extends Component {

	timer;

	constructor(props) {
    super(props);

    this.state = {active:0,images:[{caption:'Image 1',src:'/ui/img/image-01.jpg'},{caption:'Image 2',src:'/ui/img/image-02.jpg'},{caption:'Image 3',src:'/ui/img/image-03.jpg'}]};
  }
  
  componentDidMount() {

  		if(this.props.autoplay){

  			var int = (this.props.delay) ? this.props.delay : 1000;
  			this.timer = setInterval(this.next,int);

  		}

  		if(this.props.preload){

  			this.preload();

  		}

	}
	
	componentWillUnmount() {
			if(this.timer) clearInterval(this.timer);
	  }
	 
	 	preload = () => {

	 		this.state.images.map((i)=>{

	 			if(i.src){
	 				let img = new Image();
	 				img.src = i.src;
	 			}
	 			if(i.asset){

	 				let imgL = new Image();
	 				imgL.src = i.asset.large;

	 				let imgS = new Image();
	 				imgS.src = i.asset.small;

	 			}
	 		})
	 	}

	  prev = () => {

	  	let ix = this.state.active;
	  	ix--;

	  	this.updateIx(ix);
	  }

	   next = () => {

	  	let ix = this.state.active;
	  	ix++;

	  	this.updateIx(ix);
	  }

	 updateIx = (ix) => {

	 	let items = this.props.images || this.props.items || [];

	  	const last = items.length - 1;

	  	// Ensure ix is within range
	  	if(ix < 0) ix = last;
	  	if(ix > last) ix = 0;

	  	this.setState({active:ix});

	  }

	  item = (item,ix) => {

	  	let items = this.props.images || this.props.items || [];

	  	if(!items.length) return null;

	  	const active = (ix == this.state.active);
	  	const asset = item.asset || item;
	  	const styles = {position:'absolute',width:'100%',height:'100%',top:0,left:0,display:'block'};

	  	const style = (active) ? {...styles ,opacity:1,pointerEvents:'all'} : {...styles,opacity:0,pointerEvents:'none'};

	  	const itemHTML = (this.props.getItem) ? (this.props.getItem(item,ix,active)) : <Image  fluid={true} {  ...asset } />;

	  	return (<div style={style}>{itemHTML}</div>);

	  }

	  active = () => {

	  	let items = this.props.images || this.props.items || [];

	  	if(!items.length) return null;

	  	if(this.props.getActive) return (this.props.getActive(items[this.state.active]));

	  	if(items[this.state.active].asset) return (<Image  fluid={true} {  ...items[this.state.active].asset } />)
	  	else return (<Image  fluid={true} {  ...items[this.state.active] } />);

	  }

	  caption = () => {
	  	let items = this.props.images || this.props.items || [];

	  	if(!items.length) return null;

	  	if(this.props.getCaption) return (this.props.getCaption(items[this.state.active]));

	  	return items[this.state.active].caption;

	  }
  
  render() {
  	let items = this.props.images || this.props.items || [];

	const nav = (items.length > 1) ? (<div className="Gallery-navigation">
 			<div className="Gallery-prev">
 				<div style={{cursor:'pointer'}} onClick={this.prev}><div className="Icon Icon--arrow-left"/></div>
 			</div>
 			<div className="Gallery-next">
 				<div style={{cursor:'pointer'}}  onClick={this.next}><div className="Icon Icon--arrow-right"/></div>
 			</div>
 		</div>) : null;

	let modifier = (this.props.modifier) ? "Gallery--"+ this.props.modifier : null;

	let style = null;

	if(this.props.fluid){

		style = {

                            position:'absolute',
                            top:0,
                            left:0,
                            width:'100%',
                            height:'100%',


                        }

	}

    return (
      <div className={"Gallery "+modifier} style={style} >

 		{ nav }

 		<div onClick={this.next} className="Gallery-body">

 			{items.map((item,ix)=>(
 				this.item(item,ix)
 			))}
 			
 		</div>
 		<div className="Gallery-caption">
 			{this.caption()}
 		</div>
      </div>
    );
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/js/_core/components/Gallery/Gallery.jsx